import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';
import { useSelector } from 'react-redux';


export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const user = useSelector(state => state.user);
  const account = useSelector(state => state.account);
  const authToken = localStorage.getItem('authToken')

  const isAuthenticated = user?.details && account?.details && authToken;

  console.log(user?.details?.firstname)
  console.log(account?.details?.id)
  console.log(authToken)

  if (!user || !account) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}